import { Search } from '../components/atomic/search.vue';
Vue.component('search', Search);